/*!	
* FitText.js 1.0 jQuery free version
*
* Copyright 2011, Dave Rupert http://daverupert.com 
* Released under the WTFPL license 
* http://sam.zoy.org/wtfpl/
* Modified by Slawomir Kolodziej http://slawekk.info
*
* Date: Tue Aug 09 2011 10:45:54 GMT+0200 (CEST)
*/
(function () {

  var addEvent = function (el, type, fn) {
    if (el.addEventListener)
      el.addEventListener(type, fn, false);
    else
      el.attachEvent('on' + type, fn);
  };

  var extend = function (obj, ext) {
    for (var key in ext)
      if (ext.hasOwnProperty(key))
        obj[key] = ext[key];
    return obj;
  };

  window.fitText = function (el, kompressor, options) {

    var settings = extend({
      'minFontSize': -1 / 0,
      'maxFontSize': 1 / 0
    }, options);

    var fit = function (el) {
      var compressor = kompressor || 1;

      var resizer = function () {
        try{
          el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)) + 'px';
        }catch(e){
          console.error(e)
        }
      };

      // Call once to set.
      resizer();

      // Bind events
      addEvent(window, 'resize', resizer);
      addEvent(window, 'orientationchange', resizer);
      addEvent(window, 'load', resizer);
    };

    if (el.length)
      for (var i = 0; i < el.length; i++)
        fit(el[i]);
    else
      fit(el);

    // return set of elements
    return el;
  };
})();

var ONE_REM = 16;

export function setupFitText() {
  if (window.innerWidth < 1024) {
    let initialH1Elements = document.querySelectorAll('h1');
    let initialH2Elements = document.querySelectorAll('h2');

    window.fitText(initialH1Elements, 1.2, { "maxFontSize": 4.5 * ONE_REM })
    window.fitText(initialH2Elements, 1.2, { "maxFontSize": 2 * ONE_REM })

    // observer changes in the node amount
    // and attach resizing to newcomer headlines
    const config = { childList: true, subtree: true };
    const observer = new MutationObserver(() => { resizeNewlyGeneratedHeadlines(initialH1Elements, initialH2Elements) });
    observer.observe(document.querySelector("body"), config);
  }
}

function resizeNewlyGeneratedHeadlines(initialH1Elements, initialH2Elements) {
  let h1Elements = document.querySelectorAll('h1');
  let h2Elements = document.querySelectorAll('h2');

  let newH1 = Array.from(h1Elements).filter(item => !Array.from(initialH1Elements).includes(item));
  let newH2 = Array.from(h2Elements).filter(item => !Array.from(initialH2Elements).includes(item));

  if (newH1.length > 0)
    window.fitText(newH1, 1.2, { "maxFontSize": 4.5 * ONE_REM });
  if (newH2.length > 0)
    window.fitText(newH2, 1.2, { "maxFontSize": 2 * ONE_REM });
}